// extracted by mini-css-extract-plugin
export default {"meinian-inspiration-style-batch-check":"index_meinian-inspiration-style-batch-check__iS3+m"};